import React from 'react';
import { Typography, Grid, Box } from '@mui/material';
// import useStyles from './styles';
// 

function PersonDetails(props) {
  const classes = {
    listItem: {
      padding: '2px'
    },
    total: {
      fontWeight: '700'
    },
    title: {
      marginTop: '2px',
      padding: '10px',
    }
  }
  const { firstname, lastname, document, phoneNumber, cellPhoneNumber, email } = props.formValues;

  return (
    <Grid item xs={12} sm={5}>
      <Typography
        fontWeight={400}
        variant="h5"
        gutterBottom
        sx={classes.title}>
        Datos Personales
      </Typography>
      <Grid
        container
        sx={{ paddingLeft: '10px', paddingBottom: '10px' }}
      >
        <Box pl={1}>
          <Grid item xs={12}>
            <Typography gutterBottom>DNI: {document}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom>Nombre: {lastname} {firstname}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom>Télefono: {phoneNumber}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom>Celular: {cellPhoneNumber}</Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography gutterBottom>Email: {email}</Typography>
          </Grid>
        </Box>
      </Grid>
    </Grid>
  );
}

export default PersonDetails;